// extracted by mini-css-extract-plugin
export default {"navbarcontainer":"navbar_navbarcontainer__wMdrS","button":"navbar_button__8EVwm"};